module.exports = __webpack_public_path__ + "static/media/Data Asset Page Icons-03.e6450f8b.svg";